import "core-js/modules/web.dom.iterable";
import Vue from "vue";
import SvgIcon from "@/components/SvgIcon"; // svg component
import { basename } from "path";

// register globally
Vue.component("svg-icon", SvgIcon);
var req = require.context("./svg", false, /\.svg$/);
var requireAll = function requireAll(requireContext) {
  window.ICON_NAME_LIST = requireContext.keys().map(function (item) {
    return basename(item, ".svg");
  });
  return requireContext.keys().map(requireContext);
};
requireAll(req);